"use client";
// Sign-in pages in the auth card layout; signed-in users go to their dashboard.
import { useAuth } from "context/UseContext";
import AuthLayout from "layouts/Auth";
import { Navigate, OutletProvider } from "lib/router";

export default function Layout({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/dashboard" />;
  return (
    <OutletProvider outlet={children}>
      <AuthLayout />
    </OutletProvider>
  );
}
